import { authedAxios } from '../shared/axiosWrapper';
import {
  AD_BASE_COMPANY_PATH,
  AD_BASE_ACCOUNTS_PATH,
  AD_BASE_SPLIT_CONVERSATION_EMAILS_PATH,
} from '../constants';

export default {
  fetchMyCompany() {
    return authedAxios.get(AD_BASE_COMPANY_PATH);
  },

  updateMyCompany(company) {
    return authedAxios.put(AD_BASE_COMPANY_PATH, company);
  },

  // Senders whose new emails each start their own conversation
  fetchSplitConversationEmails() {
    return authedAxios.get(AD_BASE_SPLIT_CONVERSATION_EMAILS_PATH);
  },

  updateSplitConversationEmails(emails) {
    return authedAxios.put(AD_BASE_SPLIT_CONVERSATION_EMAILS_PATH, { emails });
  },

  deleteMyCompanyLogo() {
    return authedAxios.delete(AD_BASE_COMPANY_PATH + 'logo/');
  },

  fetchCompany(id) {
    return authedAxios.get(AD_BASE_ACCOUNTS_PATH + id);
  },

  fetchAll(params = {}) {
    return authedAxios.get(AD_BASE_ACCOUNTS_PATH, {
      params: {
        filter: params.filters,
        sort: params.sort,
        limit: params.limit,
        paid: params.paid,
      },
    });
  },

  createCompany(company) {
    return authedAxios.post(AD_BASE_ACCOUNTS_PATH, company);
  },

  updateCompany(id, company) {
    return authedAxios.put(AD_BASE_ACCOUNTS_PATH + id, company);
  },

  fetchAccountSettings(id) {
    return authedAxios.get(AD_BASE_ACCOUNTS_PATH + id + '/settings/');
  },

  fetchCompanyApiToken(type) {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'token/' + type);
  },

  generateApiToken(type) {
    return authedAxios.post(AD_BASE_COMPANY_PATH + 'token/' + type);
  },

  getCompanyLogoSignedUrl(mimeType) {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'logo-signed-url', {
      params: { 'mime-type': mimeType },
    });
  },

  checkDomains() {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'valid-domains/check-email');
  },

  checkPrimary() {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'valid-domains/check-primary');
  },

  listDomains(type) {
    return authedAxios.get(AD_BASE_COMPANY_PATH + 'valid-domains/' + type);
  },

  listDomainsByCompany(id, type) {
    return authedAxios.get(
      AD_BASE_ACCOUNTS_PATH + id + '/valid-domains/' + type
    );
  },

  addDomain(type, body) {
    return authedAxios.post(AD_BASE_COMPANY_PATH + 'valid-domains/' + type, body);
  },

  addDomainsByCompany(id, type, body) {
    return authedAxios.post(
      AD_BASE_ACCOUNTS_PATH + id + '/valid-domains/' + type,
      body
    );
  },

  updateDomain(type, id, body) {
    return authedAxios.put(
      AD_BASE_COMPANY_PATH + 'valid-domains/' + type + '/' + id,
      body
    );
  },

  deleteDomain(type, id) {
    return authedAxios.delete(
      AD_BASE_COMPANY_PATH + 'valid-domains/' + type + '/' + id
    );
  },

  fetchDomain(type, id) {
    return authedAxios.get(
      AD_BASE_COMPANY_PATH + 'valid-domains/' + type + '/' + id
    );
  },

  addWifiUuid() {
    return authedAxios.post(AD_BASE_COMPANY_PATH + 'valid-domains/wifi', {
      wifi: 'newUuid'
    });
  }
};
